var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNomenclature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.97 5.2017L10.72 0.687639C10.4996 0.565841 10.2518 0.501953 10 0.501953C9.74816 0.501953 9.50043 0.565841 9.28 0.687639L1.03 5.20358C0.794395 5.33249 0.597722 5.52229 0.460517 5.75316C0.323313 5.98404 0.25061 6.24751 0.25 6.51608V15.4823C0.25061 15.7509 0.323313 16.0144 0.460517 16.2452C0.597722 16.4761 0.794395 16.6659 1.03 16.7948L9.28 21.3108C9.50043 21.4326 9.74816 21.4965 10 21.4965C10.2518 21.4965 10.4996 21.4326 10.72 21.3108L18.97 16.7948C19.2056 16.6659 19.4023 16.4761 19.5395 16.2452C19.6767 16.0144 19.7494 15.7509 19.75 15.4823V6.51701C19.7499 6.24797 19.6774 5.98391 19.5402 5.7525C19.403 5.52108 19.206 5.33084 18.97 5.2017ZM10 2.00014L17.5319 6.12514L14.7409 7.65326L7.20813 3.52826L10 2.00014ZM10 10.2501L2.46812 6.12514L5.64625 4.38514L13.1781 8.51014L10 10.2501ZM1.75 7.43764L9.25 11.542V19.5848L1.75 15.4833V7.43764ZM18.25 15.4795L10.75 19.5848V11.5458L13.75 9.9042V13.2501C13.75 13.4491 13.829 13.6398 13.9697 13.7805C14.1103 13.9211 14.3011 14.0001 14.5 14.0001C14.6989 14.0001 14.8897 13.9211 15.0303 13.7805C15.171 13.6398 15.25 13.4491 15.25 13.2501V9.08295L18.25 7.43764V15.4786V15.4795Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNomenclature);
export default __webpack_public_path__ + "static/media/Nomenclature.222a82a031d7f55c06cc07a975415858.svg";
export { ForwardRef as ReactComponent };